module.exports = __webpack_public_path__ + "img/map_mobile_6.39837b49.png";